import React from 'react';
import { useTranslation } from 'react-i18next';
import './Features.css';

const icons = {
  map: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  teams: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  trophy: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
    </svg>
  ),
  lineup: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
    </svg>
  ),
  live: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  chat: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
    </svg>
  ),
  search: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  bell: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  ),
  calendar: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  stats: (
    <svg className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  )
};

const bookingSlots = [
  { time: '17:00', state: 'free' },
  { time: '18:00', state: 'taken' },
  { time: '19:00', state: 'picked' },
  { time: '20:00', state: 'free' },
  { time: '21:00', state: 'taken' },
  { time: '22:00', state: 'free' }
];

const rosterColors = ['#7c54e3', '#2b9bd6', '#d65f8f', '#c98f2f', '#3fae8a'];

const CompactCard = ({ icon, title, description }) => (
  <div className="tk-card tk-card--compact">
    <span className="tk-chip">{icon}</span>
    <div>
      <h3 className="tk-card-title">{title}</h3>
      <p className="tk-card-desc">{description}</p>
    </div>
  </div>
);

const Features = () => {
  const { t } = useTranslation();

  const compact = [
    { icon: icons.live, key: 'arrival' },
    { icon: icons.chat, key: 'chat' },
    { icon: icons.search, key: 'playerSearch' },
    { icon: icons.bell, key: 'notifications' },
    { icon: icons.stats, key: 'personalStats' }
  ];

  return (
    <section id="features" className="bg-gray-900 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('features.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="tk-features-grid">
          <div className="tk-card tk-card--media tk-card--span2">
            <div className="tk-card-body">
              <span className="tk-chip">{icons.map}</span>
              <h3 className="tk-card-title">{t('features.findGames.title')}</h3>
              <p className="tk-card-desc">{t('features.findGames.description')}</p>
            </div>
            <div className="tk-card-media">
              <img src="/img/app-hero.jpg" alt="" />
            </div>
          </div>

          <div className="tk-card">
            <span className="tk-chip">{icons.trophy}</span>
            <h3 className="tk-card-title">{t('features.tournaments.title')}</h3>
            <p className="tk-card-desc">{t('features.tournaments.description')}</p>
            <div className="tk-standings" aria-hidden="true">
              {[['Titanes FC', 12], ['La Banda', 10], ['Alianza 9', 8]].map(([name, pts], i) => (
                <div className="tk-standings-row" key={name}>
                  <span className="tk-standings-rank">{i + 1}</span>
                  <span className="tk-standings-name">{name}</span>
                  <span className="tk-standings-pts">{pts} pts</span>
                </div>
              ))}
            </div>
          </div>

          <div className="tk-card">
            <span className="tk-chip">{icons.lineup}</span>
            <h3 className="tk-card-title">{t('features.lineups.title')}</h3>
            <p className="tk-card-desc">{t('features.lineups.description')}</p>
            <div className="tk-pitch" aria-hidden="true">
              <span className="tk-pitch-dot" style={{ left: '12%', top: '44%' }}></span>
              <span className="tk-pitch-dot" style={{ left: '30%', top: '18%' }}></span>
              <span className="tk-pitch-dot" style={{ left: '30%', top: '70%' }}></span>
              <span className="tk-pitch-dot" style={{ left: '58%', top: '44%' }}></span>
              <span className="tk-pitch-dot" style={{ left: '80%', top: '24%' }}></span>
              <span className="tk-pitch-dot" style={{ left: '80%', top: '64%' }}></span>
            </div>
          </div>

          <div className="tk-card tk-card--span2">
            <span className="tk-chip">{icons.teams}</span>
            <h3 className="tk-card-title">{t('features.organizeTeams.title')}</h3>
            <p className="tk-card-desc">{t('features.organizeTeams.description')}</p>
            <div className="tk-roster" aria-hidden="true">
              {['JM', 'CA', 'LR', 'PT', 'DV'].map((initials, i) => (
                <span
                  className="tk-roster-avatar"
                  style={{ backgroundColor: rosterColors[i] }}
                  key={initials}
                >
                  {initials}
                </span>
              ))}
              <span className="tk-roster-avatar tk-roster-avatar--more">+9</span>
            </div>
          </div>

          <div className="tk-card tk-card--span3 tk-booking">
            <div className="tk-booking-body">
              <span className="tk-chip">{icons.calendar}</span>
              <h3 className="tk-card-title">{t('features.booking.title')}</h3>
              <p className="tk-card-desc">{t('features.booking.description')}</p>
            </div>
            <div className="tk-slots" aria-hidden="true">
              {bookingSlots.map(({ time, state }) => (
                <span className={`tk-slot tk-slot--${state}`} key={time}>{time}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="tk-compact-grid">
          {compact.map(({ icon, key }) => (
            <CompactCard
              key={key}
              icon={icon}
              title={t(`features.${key}.title`)}
              description={t(`features.${key}.description`)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
